import CustomSelect from "../vendors/custom-select";
import Common from './common';

export default {
    init() {
        console.log('load Projets liste');
        this.imgThumbs = ['img-main', 'img-masse', 'img-coupe'];
        this.imgShow = 'img-main';

        // JavaScript to be fired on all pages, after page specific JS is fired
        const catSelect = new CustomSelect('.select-cat', (value) => {
            this.applyFilter();
        });

        const anneeSelect = new CustomSelect('.select-annee', (value) => {
            this.applyFilter();
        });

        const gridWrapper = document.querySelector('.grid');
        const radioSwitch = document.querySelectorAll('input[name="display"]');

        radioSwitch.forEach((radioButton) => {
            radioButton.addEventListener('click', () => {
                // Retrieve the value of the clicked radio button
                const selectedValue = radioButton.value;
                this.thumbSwitch (selectedValue);
            });
        });

        const radioStatus = document.querySelectorAll('input[name="status"]');

        if (radioStatus.length > 0) {
            radioStatus.forEach((radioButton) => {
                radioButton.addEventListener('click', () => {
                    this.applyFilter();
                });
            });
        }

        catSelect.init();
        anneeSelect.init();

        this.imageHover ();
        this.initHoverArchive ();

        // Common.fadeOut (gridWrapper, 1000);
    },

    applyFilter () {
        const projects = document.querySelectorAll('.grid-item');
        const prjStatus = document.querySelector('input[name="status"]:checked');
        const nombres = document.querySelector('.projets-total .nombre');

        let nombre = 0;
        const filters = [
            document.getElementsByName("category")[0].value,
            document.getElementsByName("annee")[0].value
        ];

        if ( prjStatus ) {
            filters.push (prjStatus.value);
        }

        projects.forEach ( (projet) => {
            let visible = true;
            let classes = projet.className;
            projet.classList.remove('visible');

            filters.every( filter => {
                if ( '' !== filter.trim () ) {
                    let regEx = new RegExp(filter.trim (), 'gi' );
                    visible = regEx.test(classes);
                    console.log (filter, visible);

                    if (visible == false) {
                        return false;
                    }
                }
                return true;
            });

            console.log (classes, filters, visible);

            if ( visible ) {
                Common.fadeIn(projet, 500);
                projet.classList.add('visible');
                nombre ++;
            } else {
                projet.style.display = 'none';
                //Common.fadeOut(projet, 300);
                // $(e).hide();
            }
        })

        /*if ( nombre == 0 ) {
            document.querySelector('.projets-total').style.visibility = 'hidden';
        } else {
            document.querySelector('.projets-total').style.visibility = 'visible';
        }

        nombres.innerHTML = nombre;*/
    },

    imageHover () {
        const projects = document.querySelectorAll('.project-item');
        let indexImg = this.imgThumbs.indexOf(this.imgShow);
        let nIntervId;

        projects.forEach ((projet) => {
            projet.querySelector('a').addEventListener ('mouseover', (e) => {
                const figure = projet.querySelector('figure');

                let nextIndexImg = (indexImg + 1) % this.imgThumbs.length;
                this.imgSwitch(figure, this.imgThumbs[indexImg], this.imgThumbs[nextIndexImg]);
                indexImg = nextIndexImg;

                nIntervId = setInterval (()=>{
                    // console.log (this.imgThumbs[indexImg], 'mouseover');
                    let nextIndexImg = (indexImg + 1) % this.imgThumbs.length;
                    this.imgSwitch(figure, this.imgThumbs[indexImg], this.imgThumbs[nextIndexImg]);
                    indexImg = nextIndexImg;

                }, 1500);
            });

            projet.querySelector('a').addEventListener ('mouseout', (e) => {
                console.log (e.currentTarget, 'mouseout');
                const figure = projet.querySelector('figure');

                this.imgSwitch(figure, this.imgThumbs[indexImg], this.imgShow);
                indexImg = this.imgThumbs.indexOf(this.imgShow);
                clearInterval(nIntervId);
            });
        });
    },

    imgSwitch ( figure, oldIndex, newIndex ) {
        let newImg = figure.querySelector('.' + newIndex);

        if ( newImg ) {
            let oldImgFn = () => {
                if (figure.querySelector('.' + oldIndex))
                    return figure.querySelector('.' + oldIndex);
                else if (figure.querySelector('.' + this.imgShow))
                    return figure.querySelector('.' + this.imgShow);

                return figure.querySelector('.' + 'img-main');
            }

            let oldImg = oldImgFn ();

            oldImg.style.transform = 'translate(100%, 0)';
            oldImg.style.zIndex = 0;
            newImg.style.transform = 'translate(0, 0)';
            newImg.style.zIndex = 2;
        }
    },

    thumbSwitch ( newImgShow ) {
        const projects = document.querySelectorAll('.project-item');

        projects.forEach ( (projet) => {
            const figure = projet.querySelector('figure');
            this.imgSwitch(figure, this.imgShow, newImgShow);
        });

        this.imgShow = newImgShow;
    },

    initHoverArchive () {
        const trows = [... document.querySelectorAll('.trow')];

        trows.forEach((row) => {
            row.addEventListener ('click', (event) => {
                const link = row.querySelector('a');

                if (link) {
                    document.location.href = link.href;
                }
            })
        })
    },

    finalize () {
        const nbPrj = document.querySelectorAll('.project-item');
        // const nombres = document.querySelector('.projets-total .nombre');

        // console.log (nombres);
        // nombres.innerHTML = nbPrj.length;
    }
};
